// vip 路由
import {
  loadPageFail
} from '../lib/units';
import index from '../pages/toutiaoApp/index.vue'
import extendingCenter from '../pages/toutiaoApp/extendingCenter.vue'

export default [
  {
    name: 'toutiao',
    path: '/extendingCenter',
    component: index,
    children: [
      {
        name: 'extendingCenter',
        path: '/extendingCenter',
        meta: {
          title: '推广中心 ',
          newZhugeTitle: '推广中心',
        },
        component: extendingCenter,
      },
      {
        name: 'myEarnings',
        path: '/myEarnings',
        meta: {
          title: '我的收益 ',
          newZhugeTitle: '我的收益',
        },
        component: resolve => require(['../pages/toutiaoApp/myEarnings-free.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '我的收益',
            err
          });
        })
      },
      {
        name: 'addData',
        path: '/addData',
        meta: {
          title: '广告数据',
          newZhugeTitle: '广告数据',
        },
        component: resolve => require(['../pages/toutiaoApp/addData-free.vue'], resolve, (err) => {
          loadPageFail({
            pagename: '广告数据',
            err
          })
        })
      },
    ],
  },
  {
    name: 'cashWithdrawal',
    path: '/cashWithdrawal',
    meta: {
        title: '申请提现 ',
        newZhugeTitle: '申请提现',
    },
    component: resolve => require(['../pages/toutiaoApp/cashWithdrawal-free.vue'], resolve, (err) => {
        loadPageFail({
            pagename: '申请提现',
            err
        });
    })
  },
  {
    name: 'nameAuthentication',
    path: '/nameAuthentication',
    meta: {
        title: '实名认证',
        newZhugeTitle: '实名认证',
    },
    component: resolve => require(['../pages/toutiaoApp/nameAuthentication-free.vue'], resolve, (err) => {
        loadPageFail({
            pagename: '实名认证',
            err
        });
    })
  },
  {
    name: 'authenticationSuccess',
    path: '/authenticationSuccess',
    meta: {
        title: '实名认证',
        newZhugeTitle: '实名认证',
    },
    component: resolve => require(['../pages/toutiaoApp/nameAuthentication_success.vue'], resolve, (err) => {
        loadPageFail({
            pagename: '实名认证',
            err
        });
    })
  },
  {
    name: 'authenticationInformation',
    path: '/authenticationInformation',
    meta: {
        title: '认证须知',
        newZhugeTitle: '认证须知',
    },
    component: resolve => require(['../pages/toutiaoApp/authenticationInformation.vue'], resolve, (err) => {
        loadPageFail({
          pagename: '认证须知',
          err
        })
    })
  },
  {
    name: 'myTeams',
    path: '/myTeams',
    meta: {
      title: '我的团队',
      newZhugeTitle: '我的团队',
    },
    component: resolve => require(['../pages/toutiaoApp/myTeams.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '我的团队',
        err
      })
    })
  },
  {
    name: 'yixinliIntroduce',
    path: '/yixinliIntroduce',
    meta: {
      title: '关于壹心理',
      newZhugeTitle: '关于壹心理',
    },
    component: resolve => require(['../pages/toutiaoApp/yixinliIntroduce.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '关于壹心理',
        err
      })
    })
  },
  {
    name: 'authenticationWorker',
    path: '/authenticationWorker',
    meta: {
      title: '自由职业合作服务协议',
      newZhugeTitle: '自由职业合作服务协议',
    },
    component: resolve => require(['../pages/toutiaoApp/authenticationWorker.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '自由职业合作服务协议',
        err
      })
    })
  },
  {
    name: 'certificationSuccess',
    path: '/certificationSuccess',
    meta: {
      title: '认证',
      newZhugeTitle: '认证',
    },
    component: resolve => require(['../pages/toutiaoApp/certificationSuccess.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '认证',
        err
      })
    })
  },
  {
    name: 'ttSearch',
    path: '/ttSearch',
    meta: {
      title: '搜索',
      newZhugeTitle: '搜索',
    },
    component: resolve => require(['../pages/toutiaoApp/search.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '搜索',
        err
      })
    })
  },
  {
      name: 'toutiaono',
      path: '/toutiaono',
      meta: {
          title: '抖音屏蔽页',
          fullTitle: function() {
              return '抖音屏蔽页';
          }
      },
      component: resolve => require(['../pages/toutiaoApp/toutiaono.vue'], resolve, (err) => {
          loadPageFail({
              pagename: '抖音屏蔽页',
              err
          });
      })
  },
]



// WEBPACK FOOTER //
// ./src/router/toutiao_app.js